// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"StreakCard_bodyWrapper__rjIVA"};